import { render, staticRenderFns } from "./NoticesRechargeProcessedRequests.vue?vue&type=template&id=4883e614"
import script from "./NoticesRechargeProcessedRequests.vue?vue&type=script&lang=js"
export * from "./NoticesRechargeProcessedRequests.vue?vue&type=script&lang=js"
import style0 from "./NoticesRechargeProcessedRequests.vue?vue&type=style&index=0&id=4883e614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports